import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { injectIntl } from "react-intl";

const query = `
  query SourceTypes {
    sourceTypes {
      items
      total
    }
  }
`;

const SourceTypeSelect = ({ id = "type", name = "type", intl, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.sourceTypes, []);
  const handleGetValue = useCallback(element => element, []);
  const handleGetLabel = useCallback(element => intl.formatMessage({ id: `source.type.in.${element}` }), [intl]);

  return (
    <EntitiesSelector
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

SourceTypeSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default injectIntl(SourceTypeSelect);
